/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { StatelessComponent, Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Grid, Row, Column, HeaderCompound, Button, Heading, cls } from './../../packages/components';
import './_styles.scss';
import Translator from '../../requests/apa/Translator';
import Assets from '../../requests/apa/Asset';
import { ButtonVariant } from '../../packages/components/lib/Button';
import { autobind } from '../../packages/core/lib';
import { DETAIl_S } from '../utils/constants';
import { ColoredButton } from '../../packages/components/lib/ColoredButton/';
import { getLevelGeneric, getSimpleGet } from '../../requests/loader';
import Device from '../../devices/device';
import Utils, {shouldMetadataInfoShowed} from '../../utils/Utils';
import Launcher from '../../requests/apa/Launcher';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import CardHelper from 'src/components/CardNew/helpers';
import { VCARD_COMPONENT, QUE_INCLUYE } from '../../authentication/utils/constansMetrics';
import logger from 'src/utils/logger/logger';
import UtilsPagos from "../../utils/payway/UtilsPagos";
import { getAndroidTvPolicesLabels, getAddonAndroidMessageClassNames } from '../../payments/utils/Utils';
import { showModal, MODAL_CALL_CENTER, MODAL_PIN } from '../../actions/modal';
import { MODAL_PIN_CODE_PURCHASE_TYPE } from '../../components/Modal/ModalPinCode';
import store from '../../store';
import LandingComercialAddOn from './LandingComercialAddOn';
import LandingComercialChannels from './LandingComercialChannels';
import NewSectionInfoAddOn from './newSectionInfoAddOn/NewSectionInfoAddOn';
import NewSectionInfoChannel from './newSectionInfoChannel/NewSectionInfoChannel';
import { CANAL_OFFER } from './const';



export interface IDetailSelector {
    id: string,
    providerLogo: string,
    pbi: any,
    buttons: any[],
    trial: any,
    vcardData: any
}

export interface IDetailSelectorState {
    imgHighlightHorizontalSrc: string,
    imgOneSrc: string,
    titleOne: string,
    imgTwoSrc: string,
    titleTwo: string,
    imgThreeSrc: string,
    titleThree: string,
    imgHighlightVerticalSrc: string,
    superHighlight: object,
    posters: object
}

const DetailHeader: StatelessComponent = () => {
    return (
        <Row className={cls(`${DETAIl_S}-row1`)}>
            <Column lg={12} className={cls(`${DETAIl_S}-header-buttons`)}>
                <ColoredButton color="yellow" className={cls(`${DETAIl_S}-row-button`)}>
                    {/* <i className="fa fa-reply" /> */}
                    {'REGRESAR'}
                </ColoredButton>
            </Column>
        </Row>
    );
};



 class DetailSelector extends Component<RouteComponentProps & IDetailSelector, IDetailSelectorState> {

    public keys = Device.getDevice() && Device.getDevice().getKeys() || null;
    private data: IDetailSelector;
    private islive: Boolean = false;
    private groupId: string = '';
    private vcardData: any = null;
    private offerType: string | null | undefined = undefined;

    constructor(props: RouteComponentProps & IDetailSelector) {
        super(props);
        const {history: {location: {state: {activePlan = {}, islive = false, groupId = '', vcardData = null } = {} } = {} } } = props;
        this.data = activePlan;
        this.islive = islive;
        this.groupId = groupId;
        this.vcardData = vcardData;

        this.offerType = undefined;
      }

    componentDidMount = () => {
        const temp: any = window;
        temp.SpatialNavigation.focus();
        document && document.removeEventListener("keydown", this.onKeyPress, true);
        document && document.addEventListener("keydown", this.onKeyPress, true);
        this.getImages();
    };

    private getCarrousel(module: any){

        const {components: {component = []} = {}} = module || {};
        const carrousel = component.filter((section: {name: string})=> section.name === 'carrousel');
        const [result = {}] = carrousel;

        return result;
    }

    @autobind
    async getImages(){
        const {pbi: {family : node =''}} = this.data;
        const params = {
            node,
            type:'abonos',
        };

        getLevelGeneric(params).then((res)=>{
            this.offerType = res.offer_type
            if (res.modules) {
                let top = res.modules.module ? res.modules.module[0] : res.modules[0];
                let resto = res.modules.module ? res.modules.module[1] : res.modules[1];
                const url = Launcher.get("akamai_mfwk");
                const { properties: { url: urlHighlight = '' } = {} } = this.getCarrousel(top);
                const { properties: { url: urlVertical = '' } = {} } = this.getCarrousel(resto);

                if (urlHighlight !== '' && urlVertical !== '') {
                    const requestHighlight = Utils.getRequest(urlHighlight);
                    const requestVertical = Utils.getRequest(urlVertical);

                    Promise.all([
                        getSimpleGet(`http://${url}${requestHighlight.uri}`, { ...requestHighlight.params }),
                        getSimpleGet(`http://${url}${requestVertical.uri}`, { ...requestVertical.params })
                    ]).then((result) => {
                        const [highlightResult = {}, verticalResult = {}] = result;
                        const { groups: [verticalHighlight = false, One = false, Two = false, Three = false] = [] } = verticalResult || { groups: [] };
                        const { highlight: [firstHighlight] = [] } = highlightResult || { highlight: [] };
                        const { image_highlight = this.state.imgHighlightHorizontalSrc } = firstHighlight || { image_highlight: '' };
                        this.setState({
                            imgHighlightHorizontalSrc: image_highlight,
                            imgOneSrc: One && One.images && One.images.horizontal ? One.images.horizontal : '',
                            imgTwoSrc: Two && Two.images && Two.images.horizontal ? Two.images.horizontal : '',
                            imgThreeSrc: Three && Three.images && Three.images.horizontal ? Three.images.horizontal : '',
                            titleOne: One.live_enabled === "1" ? '' : CardHelper.posterTitleIsEnabled(One.proveedor_code) ? One.title : '',
                            titleTwo: Two.live_enabled === "1" ? '' : CardHelper.posterTitleIsEnabled(Two.proveedor_code) ? Two.title : '',
                            titleThree: Three.live_enabled === "1" ? '' : CardHelper.posterTitleIsEnabled(Three.proveedor_code) ? Three.title : '',
                            imgHighlightVerticalSrc: verticalHighlight && verticalHighlight.images && verticalHighlight.images.vertical ? verticalHighlight.images.vertical : '',
                            superHighlight: highlightResult,
                            posters: verticalResult
                        })
                    }).catch(e => logger.error(e));
                }
            }
        });
    }

    public componentWillUnmount(): void {
        document && document.removeEventListener("keydown", this.onKeyPress, true);
    }

    @autobind
    private showModalSusc(groupId: number, provider: string, pbi: object, cb: any): void {
        const props = {
            groupId,
            provider,
            pbi,
            backCallback: cb
        }
        const modal = {
            modalType: MODAL_CALL_CENTER,
            modalProps: props
        };
        store.dispatch(showModal(modal));
    }

    @autobind

    private handleBack():void {
        const { history } = this.props;
        history.goBack();
    }

    @autobind
    private handleFocus():void {

        const leftContainer = document.getElementsByClassName(`${DETAIl_S}-first left-container`);
        if (leftContainer.length == 1){
            leftContainer[0].scrollTop = 0;
        }
    }

    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch(currentKey){
            case "YELLOW":
                this.handleBack();
            break;
        }
    }

    private showModalPIN(pbi: object): void {
        const { history, location: {state} } = this.props;
        const metricsHistoryAddon = state?.metricsHistoryAddon;
        const { trial } = this.data;
        const modal = {
            modalType: MODAL_PIN,
            modalProps: {
                type: MODAL_PIN_CODE_PURCHASE_TYPE,
                action: 'MP_CHECAR_STATUS',
                pinIsCreated: true,
                successCallBack: () => {
                    history.push(`/detailtransaction`, this.vcardData ? {...this.vcardData, ...pbi} : {
                        ...pbi,
                        from: this.islive
                            ? '' : 'plan-selector',
                        islive: this.islive,
                        groupId: this.groupId,
                        metricsHistory: (!metricsHistoryAddon || metricsHistoryAddon === undefined )
                            ? 'tv' : undefined,
                        trial
                    });
                },
                flag: true,
            },
        };

        store.dispatch(showModal(modal));
    }

    @autobind
    private onHandleClick(producttype: string, period: string){
        const { history, location:{state} } = this.props;
        const {pbi, trial} = this.data;
        const metricsHistoryAddon = state?.metricsHistoryAddon;
        const { pin_purchase } = store.getState().pinCodes;

        Utils.sendMetric(this.props, QUE_INCLUYE, `${pbi.family.toLowerCase()} - ${period?.toLowerCase()}` ,VCARD_COMPONENT)

        if (pbi.producttype === producttype) {
            if (pin_purchase.status === 1) {
                this.showModalPIN({...pbi});
            } else {
                history.push(`/detailtransaction`, this.vcardData ? {...this.vcardData, ...pbi} : {
                    ...pbi,
                    from:this.islive
                        ? ''
                        : 'plan-selector',
                    islive: this.islive,
                    groupId: this.groupId,
                    metricsHistory: (!metricsHistoryAddon || metricsHistoryAddon === undefined )
                        ? 'tv'
                        : undefined,
                    trial
                });
            }
        } else {
            const {buttons = []} = this.data;
            let selectedPlan = buttons.find((button)=>{
                return button.producttype === producttype
            });

            if (pin_purchase.status === 1) {
                this.showModalPIN({...selectedPlan});
            } else {
                //TODO:revisar si afecta si quitamos el currency del objeto
                selectedPlan = {...selectedPlan}
                history.push(`/detailtransaction`, this.vcardData ? {...this.vcardData, ...selectedPlan} : {
                    ...selectedPlan,
                    from:'plan-selector',
                    metricsHistory: (!metricsHistoryAddon || metricsHistoryAddon === undefined )
                        ? 'tv'
                        : undefined,
                    trial
                });
            }
        }
    }

    private getAndroidTvPolicies(buttons: any[], labels: {title:string, description:string}): JSX.Element | null {
        const classes = {
            classNameContainer: `${DETAIl_S}-android-tv-policy`,
            classNameTitle: 'title-android-tv',
            classNameDescription: 'description-android-tv'
        };

        if (this.shouldShowAndroidMessage(buttons)){
            return (
                getAddonAndroidMessageClassNames(labels, classes)
            )
        }else{
            return null;
        }
    }

    shouldShowAndroidMessage(buttons: any[]){
        return UtilsPagos.shouldShowAndroidMessage(buttons);
    }

    getSectionInfo = (offerType: string | null) => {
        const { buttons } = this.data;

        if(offerType === CANAL_OFFER) return <NewSectionInfoChannel offers={buttons} onClick={this.onHandleClick} />
        
        return <NewSectionInfoAddOn
            offers={buttons}
            onClick={this.onHandleClick}
        />
    }

    variantButton:ButtonVariant = 'primary';

    getOfferTypeLayout = (offerType: string) => {
        const { superHighlight = {}, posters = {} } = this.state || {};
        if (offerType === CANAL_OFFER) {
            return <LandingComercialChannels superhighlight={superHighlight} posters={posters} />;
        }
        // Por defecto y para ADDON
        return <LandingComercialAddOn superhighlight={superHighlight} posters={posters} />;
    }

    render() {
        const { imgOneSrc = '', imgTwoSrc = '', imgThreeSrc = '',
                imgHighlightVerticalSrc = '', imgHighlightHorizontalSrc = '',
                titleOne = '', titleTwo = '', titleThree = '' } = this.state || {};
        const { providerLogo, pbi: { family = '' }, buttons } = this.data;
        const styleHighlightHorizontal: object = {backgroundImage: `url(${imgHighlightHorizontalSrc}?size&imwidth=544)`};
        const styleImageOne: object = {backgroundImage: `url(${imgOneSrc}?size&imwidth=240)`, position:`relative`};
        const styleImageTwo: object = {backgroundImage: `url(${imgTwoSrc}?size&imwidth=240)`, position:`relative`};
        const styleImageThree: object = {backgroundImage: `url(${imgThreeSrc}?size&imwidth=240)`, position:`relative`};
        const styleImageHighlightVertical: object = {backgroundImage: `url(${imgHighlightVerticalSrc}?size&imwidth=287)`};
        const descriptionKey = `${family}_subscriptionDescription_title_label`;
        const alingYellowButton = 'left';
        const back = Assets.get('subscriptionDescription_access_background', '/images/bg_landing.png');

        return (
            <div className={DETAIl_S}>
                <div className={cls(`${DETAIl_S}-relative`)}>
                    <div className={cls(`${DETAIl_S}-container`)}>
                        <Grid className={cls(`${DETAIl_S}-container-grid`)} style={{backgroundImage: `url(${back})`}}>
                            <HeaderCompound
                                disabled
                                onClick={this.handleBack}
                                onFocus={this.handleFocus}
                                textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                                icon={`${Assets.get('top_head_option_back')}`}
                                align={alingYellowButton}
                                />
                            <Row className={cls(`${DETAIl_S}-row2`)}>
                                {/* COLUMNA IZQUIERDA*/}
                                <Column  lg={6} className={cls(`${DETAIl_S}-first`, 'left-container')}>
                                    {
                                        this.offerType ? this.getSectionInfo(this.offerType) : null
                                    }
                                </Column>


                                {/* COLUMNA DERECHA*/}
                                <Column lg={6} className={cls(`${DETAIl_S}-second`)}>
                                    {
                                        this.offerType ? this.getOfferTypeLayout(this.offerType) : (
                                            <Grid className={cls(`${DETAIl_S}-second-grid`)}>
                                                <Row className={cls(`${DETAIl_S}-second-row`)}>
                                                    <Column
                                                        lg={12} className={cls(`${DETAIl_S}-first-image`)}>
                                                        <div style={styleHighlightHorizontal} className={cls(`${DETAIl_S}-first-image-bg`)}></div>
                                                    </Column>
                                                    <Column lg={12} className={cls(`${DETAIl_S}-middle`)}>
                                                        <Column lg={6} className={cls(`${DETAIl_S}-middle-imgs`)}>
                                                            <Column lg={12} className={cls(`${DETAIl_S}-middle-img`)}>
                                                                <div style={styleImageOne} className={cls(`${DETAIl_S}-middle-img-bg`)}>
                                                                    <div  className={cls(`${DETAIl_S}-middle-img-bg-text`)}> {titleOne} </div>
                                                                </div>
                                                            </Column>
                                                            {/* <Column lg={12} className={cls(`${DETAIl_S}-br`)}/> */}
                                                            <Column lg={12} className={cls(`${DETAIl_S}-middle-img`)}>
                                                                <div style={styleImageTwo} className={cls(`${DETAIl_S}-middle-img-bg`)}>
                                                                    <div  className={cls(`${DETAIl_S}-middle-img-bg-text`)}> {titleTwo} </div>
                                                                </div>
                                                            </Column>
                                                            {/* <Column lg={12} className={cls(`${DETAIl_S}-br`)}/> */}
                                                            <Column lg={12} className={cls(`${DETAIl_S}-middle-img`)}>
                                                                <div style={styleImageThree} className={cls(`${DETAIl_S}-middle-img-bg`)}>
                                                                <div  className={cls(`${DETAIl_S}-middle-img-bg-text`)}> {titleThree} </div>
                                                                </div>
                                                            </Column>
                                                        </Column>
                                                        <Column lg={6} className={cls(`${DETAIl_S}-middle-img-second`)}>
                                                            <div style={styleImageHighlightVertical} className={cls(`${DETAIl_S}-vertical-img-bg`)}/>
                                                        </Column>
                                                    </Column>
                                                </Row>
                                            </Grid>
                                        )
                                    }
                                </Column>
                            </Row>
                        </Grid>
                    </div>
                </div>
            </div>
        );
    }
}

export default DetailSelector;



// WEBPACK FOOTER //
// ./src/payments/DetailSelector/index.tsx